import { useState } from '#imports'

export const useGameSearchOverlay = () => {
    const isOpen = useState<boolean>('game:searchOverlay', () => false)

    function open() {
        isOpen.value = true
    }

    function close() {
        isOpen.value = false
    }

    function toggle() {
        isOpen.value = !isOpen.value
    }

    return { isOpen, open, close, toggle }
}
